import { postJson } from "../../core/http";

export function createMomoPayment({ productCode } = {}) {
  return postJson("/api/v1/payments/momo/create", {
    product_code: productCode,
  });
}
